// Bot (Axle Bot) chat activity per carrier truck chat — based on adminChatItemsList,
// sourced from the carrier-scoped bot-chats route.
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";

const botChats = {
	urlGET: "api/profile/carriers/:carrierId/bot-chats",
	idKey: "_id",
	listenEvent: "chatRevision",
	segmentKey: "BOT_CHATS",
	content: {
		grid: {
			tilesPerRow: 2,
			itemsPerRow: 2,
		},
		table: {
			variant: "skinny",
			orderBy: ["createdAt", "truck", "lastSentUnix"],
		},
		pagination: {
			enabled: true,
			resetScroll: true,
		},
		order: {
			defaut: {
				key: "lastSentUnix",
				dir: "desc",
			},
		},
		filters: {
			search: true,
			items: [
				{
					key: "truck",
					type: "autocomplete",
					label: "Truck",
					autocomplete: {
						provider: "smarthop",
						url: "api/profile/trucks",
						params: { options_format_show_carrier: true },
						preloadDefault: true,
						preloadImmedately: true,
						listenEvent: "profileRevision",
					},
					rules: {
						params: {
							dataRef: "carrierId",
							paramKey: "options_carrier_id_search",
						},
					},
				},
			],
		},
		groups: {
			items: [
				{
					key: "internal_ids",
					type: "checkbox",
					label: "Show Internal Ids",
				},
				{
					key: "participants",
					type: "checkbox",
					label: "Show Participants Information",
				},
			],
		},
		items: [
			{ key: "lastSentUnix", type: "unix", label: "Last Sent At" },
			{ key: "createdAt", type: "date", label: "Created", group: "internal_ids" },
			{ key: "_id", type: "id", label: "Chat ID", group: "internal_ids" },
			{ key: "truck", type: "id", label: "Truck ID", group: "internal_ids" },
			{
				key: "truck__view",
				type: "truck__view",
				label: "Truck",
				viewConfig: {
					showTeam: true,
				},
			},
			{
				key: "lastPreview",
				type: "component",
				label: "Last Message",
				table: { width: 720, minWidth: 480 },
				builder: (item) => {
					if (!item.lastPreview && !item.lastType) {
						return <span className="text-11 text-grey-500">-</span>;
					}
					return (
						<div className="flex flex-col" style={{ maxWidth: 720 }}>
							<span className="text-12 whitespace-normal break-words">{item.lastPreview || "-"}</span>
							{item.lastType ? <span className="text-11 text-grey-600">{item.lastType}</span> : null}
						</div>
					);
				},
			},
			{
				key: "activity",
				type: "component",
				label: "Activity",
				table: { width: 130 },
				builder: (item) => {
					const replyConfig = item?.lastUnanswered
						? { icon: "mark_chat_unread", color: "text-orange", tooltip: "Needs reply — last message unanswered" }
						: { icon: "done_all", color: "text-green", tooltip: "Replied — last message answered" };
					const metrics = [
						{
							icon: replyConfig.icon,
							color: replyConfig.color,
							value: null,
							tooltip: replyConfig.tooltip,
						},
						{
							icon: "chat_bubble_outline",
							color: "text-grey-600",
							value: `${item?.messageCount ?? 0}`,
							tooltip: `${item?.messageCount ?? 0} messages`,
						},
						{
							icon: "android",
							color: "text-blue",
							value: `${item?.botMessageCount ?? 0}`,
							tooltip: `${item?.botMessageCount ?? 0} bot messages`,
						},
					];
					return (
						<div className="flex flex-row items-center gap-8">
							{metrics.map((metric, idx) => (
								<Tooltip key={idx} title={metric.tooltip} arrow>
									<div className="flex flex-row items-center">
										<Icon className={`${metric.color} text-18 ${metric.value != null ? "mr-4" : ""}`}>
											{metric.icon}
										</Icon>
										{metric.value != null ? <span className="text-12 text-grey-700">{metric.value}</span> : null}
									</div>
								</Tooltip>
							))}
						</div>
					);
				},
			},
			{
				key: "menu",
				type: "menu",
				label: "Menu",
				items: [
					{
						key: "open_chat",
						label: "Open Chat",
						variant: "button",
						redirectURLBuilder: (item) => "/chat/trucks?chat_id=" + item._id,
					},
					{
						key: "chat_details",
						label: "Chat Details",
						redirectURLBuilder: (item) => "/admin/chats/" + item._id + "/details",
					},
				],
			},
		],
	},
};

export default botChats;
